import React, { useEffect } from 'react'

import {
  ToastContainer,
  Loading,
  Tooltip,
  SpacingVertical,
  SPACING_40
} from 'mailup-web-components'

import Header from './Header'
import Search from './Search'
import Results from './Results'
import ErrorFeedback from './ErrorFeedback'

import {
  deliverabilityIndexState,
  loadingState,
  pageErrorState,
  pageState
} from './recoil/state/page'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { resultsStateEmptyState } from './recoil/state/results'
import {
  deliverabilityIndexCallback,
  resetStateCallback
} from './recoil/callbacks/callbacks'
import BoxBrandShield from './BoxBrandShield'
import ModalOpportunity from 'Components/ModalOpportunity/ModalOpportunity'

const SMTPPlusList = () => {
  const loading = useRecoilValue(loadingState)
  const { error } = useRecoilValue(pageErrorState)
  const { fetchingResults } = useRecoilValue(pageState)
  const isEmptyState = useRecoilValue(resultsStateEmptyState)
  const deliverabilityIndex = useRecoilCallback(deliverabilityIndexCallback, [])
  const {
    DeliverabilityPlus,
    ScoreData: { Score }
  } = useRecoilValue(deliverabilityIndexState)
  const resetState = useRecoilCallback(resetStateCallback, [])
  useEffect(() => {
    deliverabilityIndex()
    return () => {
      resetState()
    }
  }, [])

  return (
    <>
      <ModalOpportunity />
      <Tooltip />
      <Loading open={loading && fetchingResults} />
      <Header />
      <ToastContainer />
      <div className='l-container'>
        <ErrorFeedback />
        {!error && (
          <>
            <>
              {!isEmptyState && !DeliverabilityPlus && Score >= 0 && (
                <BoxBrandShield />
              )}
              <Search />
              <SpacingVertical variant={SPACING_40} />
            </>
            {!loading && (
              <>
                <div>
                  <Results />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default SMTPPlusList
